export default __webpack_public_path__ + "./fonts/dashboard.573f733b.svg";